// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-block[data-v-4d08f556]{width:15.8rem;text-align:center;margin:auto}", ""]);
// Exports
module.exports = exports;
